import Layout from "../../../components/Layout";
import FormPutAluno from "../Formularios/formPutUser";

export default function PutAluno() {
  return Layout(FormPutAluno, "Alunos");
}
